import { FlaskReq } from "helpers/Request";

// driver
export function getSingleDriver(driver) {
  return {
    type: "GET_SINGLE_DRIVER",
    driver
  };
}
export function changeSingleDriver() {
  return {
    type: "CHANGE_SINGLE_DRIVER",
    payload: {
      showSingleDriver: false
    }
  };
}
export function getDriverList(url) {
  return dispatch => {
    return FlaskReq({
      url: `${localStorage.flask_url}/${url}`,
      method: "get"
    }).then(res => {
      const { drivers } = res.data;
      dispatch(setDriverList(drivers));
      return res;
    });
  };
}
export function setDriverList(drivers) {
  return {
    type: "DRIVER_LIST",
    payload: { drivers }
  };
}

// mechanic
export function getSingleMechanic(mechanic) {
  return {
    type: "GET_SINGLE_MECHANIC",
    mechanic
  };
}
export function changeSingleMechanic() {
  return {
    type: "CHANGE_SINGLE_MECHANIC",
    payload: {
      showSingleMechanic: false
    }
  };
}
export function getMechanicList(url) {
  return dispatch => {
    return FlaskReq({
      url: `${localStorage.flask_url}/${url}`,
      method: "get"
    }).then(res => {
      const { mechanics } = res.data;
      dispatch(setMechanicList(mechanics));
      return res;
    });
  };
}
export function setMechanicList(mechanics) {
  return {
    type: "MECHANIC_LIST",
    payload: { mechanics }
  };
}
